import { Box, Grid, Typography } from '@mui/material';
import RegisterForm from '../../components/Auth/RegisterForm';


const RegisterPage = () => {

  return (
    <Box sx={{
      backgroundColor: 'background.paper',
      justifyContent: 'center',
      margin: 'auto',
      marginTop: '3rem',
      marginBottom: '3rem',
      maxWidth: '30rem',

    }}>

      <Grid container justifyContent={'center'} p={3}>
        <Box>
          <Typography component="h2" sx={{
            fontSize: '1.5rem',
            lineHeight: '1.5',
            fontFamily: '"DM Sans", sans-serif',
            fontWeight: 700,
            margin: 0,
            textAlign: 'center',
          }}>
            Registro de cuenta
          </Typography>
          <RegisterForm />
        </Box>
      </Grid>
    </Box>

  );
};

export default RegisterPage;
